import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import ProductPageHero from "components/products/ProductPageHero.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";
import ProductScreenshotGallery from "components/products/ProductScreenshotGallery.js";
import ProductLegalLinks from "components/products/ProductLegalLinks.js";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground.js";

import GroupKittyIcon from "images/products/group-kitty/group-kitty-icon.png";
import Screenshot1 from "images/products/group-kitty/screenshot-1.png";
import Screenshot2 from "images/products/group-kitty/screenshot-2.png";
import Screenshot3 from "images/products/group-kitty/screenshot-3.png";
import FastIcon from "images/fast-icon.svg";
import ReliableIcon from "images/reliable-icon.svg";
import SimpleIcon from "images/simple-icon.svg";
import ShieldIcon from "images/shield-icon.svg";
import CustomizeIcon from "images/customize-icon.svg";
import SupportIcon from "images/support-icon.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
const WEBSITE_URL = "https://groupkitty.spurnest.com";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.spurnest.groupkitty";

const screenshots = [
  { src: Screenshot1, alt: "Group Kitty trips home", caption: "Your trips" },
  { src: Screenshot2, alt: "Group Kitty expense tracking", caption: "Track expenses" },
  { src: Screenshot3, alt: "Group Kitty settlements", caption: "Settle up" },
];

const featureCards = [
  { imageSrc: FastIcon, title: "Split Expenses", description: "Add shared costs and split them equally or by custom shares across the group." },
  { imageSrc: ReliableIcon, title: "Trip Planning", description: "Create trips, invite members, and keep every outing organized in one place." },
  { imageSrc: SimpleIcon, title: "Smart Settlements", description: "See who owes whom and settle balances with clear, minimal transactions." },
  { imageSrc: ShieldIcon, title: "Categories", description: "Food, stay, transport, activities, and more — categorize every expense." },
  { imageSrc: CustomizeIcon, title: "Multi-platform", description: "Available on Android and iOS, with a responsive web app for every screen size." },
  { imageSrc: SupportIcon, title: "Offline-friendly", description: "Keep managing trips and expenses even when connectivity is spotty." },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/products/group-kitty/privacy-policy" },
  { label: "Terms of Service", href: "/products/group-kitty/terms" },
  { label: "Refund Policy", href: "/products/group-kitty/refund-policy" },
  { label: "Visit Website", href: WEBSITE_URL },
];

export default () => {
  return (
    <AnimationRevealPage>
      <ProductPageHero
        badge="Finance & Travel"
        title="Group Kitty"
        tagline="Split group travel expenses effortlessly. Track trips, settle up, and keep everyone in sync — on mobile and the web."
        heroImage={GroupKittyIcon}
        primaryCtaText="Visit Website"
        primaryCtaUrl={WEBSITE_URL}
        secondaryCtaText="Screenshots"
        secondaryCtaUrl="#screenshots"
      />
      <MainFeature
        subheading={<Subheading>Overview</Subheading>}
        heading="Group expenses, without the spreadsheet hassle."
        description="Group Kitty is a trip and expense splitter built by Spurnest Techlabs. Create a trip, add friends, log shared costs, and let the app figure out fair settlements — so everyone pays what they owe and nothing more."
      />
      <Features
        subheading={<Subheading>Features</Subheading>}
        heading="Built for group getaways."
        description="Everything you need to manage shared money on trips — from day-one planning to final settlement."
        cards={featureCards}
        linkText=""
      />
      <div id="screenshots">
        <ProductScreenshotGallery
          heading="Mobile experience"
          description="Responsive phone screens — the same experience scales cleanly from mobile to desktop."
          screenshots={screenshots}
          variant="phone"
          centered
        />
      </div>
      <ProductLegalLinks productName="Group Kitty" links={legalLinks} />
      <GetStarted
        text="Ready to try Group Kitty?"
        primaryLinkText="Open Group Kitty"
        primaryLinkUrl={WEBSITE_URL}
        secondaryLinkText="Google Play"
        secondaryLinkUrl={PLAY_STORE_URL}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
